module.exports = __webpack_public_path__ + "4bc43170d5c878e61c67d6a5f8ca6630.jpg";